import type { BulkUploadRepository } from "../repositories/BulkUploadRepository";
import type { BulkUploadResultEntity } from "../entities/BulkUploadEntity";

export class UploadGlsBulkUseCase {
  constructor(private readonly repository: BulkUploadRepository) {}

  async execute(file: File): Promise<BulkUploadResultEntity> {
    return this.repository.uploadGls(file);
  }
}
